export default __webpack_public_path__ + "static/media/myportfolio_navicon-light.6084a2c2.svg";